import React from 'react';

import Button from '../Button';

export type ViewSelectProps = {
  value: IconType;
  onChange: (newView: string) => void;
  options: OptionType<IconType>[];
};

const getClassName = (index: number, length: number) => {
  if (index === 0) return ' rounded-l-sm';

  return index === length - 1 ? 'rounded-r-sm' : '';
};

const ViewSelect: React.FC<ViewSelectProps> = ({
  value,
  onChange,
  options,
}) => {
  const optionsLength = options.length;
  return (
    <div className="flex gap-x-0 rounded-sm">
      {options.map((option, index) => {
        return (
          <Button
            rounded={false}
            key={option.value}
            icon={option.value}
            onClick={() => onChange(option.value)}
            className={getClassName(index, optionsLength)}
            type={value === option.value ? 'primary' : 'light'}
            tooltip={typeof option.label === 'string' ? option.label : ''}
          />
        );
      })}
    </div>
  );
};

export default ViewSelect;
